module.exports = __webpack_public_path__ + "img/emp-6.f52cbed1.jpeg";